import { Button } from '@microservices/wiskey-react-components'

import { buttonStylesByMode } from '@helpers'

interface ConfiguredEntityCancelButtonProps {
  isViewDialogWindow: boolean
  onCancel: () => void
}

export const ConfiguredEntityCancelButton: React.FC<ConfiguredEntityCancelButtonProps> = props => {
  const { isViewDialogWindow, onCancel: handleCancel } = props

  return (
    <Button
      variant='outlined'
      sx={theme => ({
        ...buttonStylesByMode(theme, isViewDialogWindow),
        zIndex: 2,
        mr: 1.5,
      })}
      onClick={handleCancel}
    >
      Cancel
    </Button>
  )
}

ConfiguredEntityCancelButton.displayName = 'ConfiguredEntityCancelButton'
